import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "text-white q-mr-md",
  style: {"font-size":"12px"}
}
const _hoisted_2 = { ref: "utcClockText" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserManagementLocal = _resolveComponent("UserManagementLocal")!
  const _component_PassageDialog = _resolveComponent("PassageDialog")!
  const _component_AddDevice = _resolveComponent("AddDevice")!
  const _component_RemoveDevice = _resolveComponent("RemoveDevice")!
  const _component_ChangePassword = _resolveComponent("ChangePassword")!
  const _component_QueueCommands = _resolveComponent("QueueCommands")!
  const _component_QueueIridiumCommands = _resolveComponent("QueueIridiumCommands")!
  const _component_DeviceHistory = _resolveComponent("DeviceHistory")!
  const _component_NotificationSettings = _resolveComponent("NotificationSettings")!
  const _component_RealTimeStream = _resolveComponent("RealTimeStream")!
  const _component_RealTimeOptions = _resolveComponent("RealTimeOptions")!
  const _component_PipelineSectionManager = _resolveComponent("PipelineSectionManager")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_DeviceInfo = _resolveComponent("DeviceInfo")!
  const _component_DeviceTable = _resolveComponent("DeviceTable")!
  const _component_PigRunManager = _resolveComponent("PigRunManager")!
  const _component_ReportManager = _resolveComponent("ReportManager")!
  const _component_DownloadManager = _resolveComponent("DownloadManager")!
  const _component_BroadcastCommands = _resolveComponent("BroadcastCommands")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_Map = _resolveComponent("Map")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_PigProgressCard = _resolveComponent("PigProgressCard")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "hHh lpr fFf" }, {
    default: _withCtx(() => [
      _createVNode(_component_UserManagementLocal),
      _createVNode(_component_PassageDialog),
      _createVNode(_component_AddDevice),
      _createVNode(_component_RemoveDevice),
      _createVNode(_component_ChangePassword),
      _createVNode(_component_QueueCommands),
      _createVNode(_component_QueueIridiumCommands),
      _createVNode(_component_DeviceHistory),
      _createVNode(_component_NotificationSettings),
      _createVNode(_component_RealTimeStream),
      _createVNode(_component_RealTimeOptions),
      _createVNode(_component_PipelineSectionManager, {
        modelValue: _ctx.managePipelineSectionDialog,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.managePipelineSectionDialog) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_header, {
        elevated: "",
        class: "basic",
        style: {"background-color":"#24337a"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, { class: "bg-blue-brand text-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                dense: "",
                round: "",
                icon: "menu",
                class: "lt-md q-mr-sm",
                "aria-label": "Toggle menu",
                onClick: _ctx.openDrawer
              }, null, 8, ["onClick"]),
              _cache[16] || (_cache[16] = _createElementVNode("img", {
                src: "PropipeNorthAmericaLogo-WhiteRed.png",
                title: "ProPipe North America",
                style: {"height":"40px"}
              }, null, -1)),
              _cache[17] || (_cache[17] = _createElementVNode("div", {
                class: "gt-sm q-ml-md text-red",
                style: {"font-size":"12px"}
              }, " SMS text messaging alerts now require opt-in permission. Sign up through the user menu. ", -1)),
              _createVNode(_component_q_space),
              _createElementVNode("span", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, null, 512),
                _createVNode(_component_q_tooltip, {
                  anchor: "bottom middle",
                  self: "top middle",
                  offset: [0, 8],
                  "max-width": "280px"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" This is your current local time converted to UTC (Coordinated Universal Time), the global standard time zone used to keep all systems synchronized regardless of your location. ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createVNode(_component_q_btn, {
                round: "",
                flat: "",
                icon: "more_vert"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_list, { style: {"min-width":"200px"} }, {
                        default: _withCtx(() => [
                          (_ctx.userHasAnyRole('admin', 'superadmin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 0,
                                clickable: "",
                                onClick: _ctx.onUserManager
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                      _createTextVNode("User Manager", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('superadmin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 1,
                                clickable: "",
                                onClick: _ctx.onGroupAssignment
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                      _createTextVNode("Group Assignment", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (
                  _ctx.userHasAnyRole('metrics') &&
                  _ctx.userHasAnyRole('admin', 'superadmin')
                )
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 2,
                                clickable: "",
                                onClick: _ctx.onSystemMetrics
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                      _createTextVNode("System Metrics", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('admin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 3,
                                clickable: "",
                                onClick: _ctx.onPipelineSectionManager
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                      _createTextVNode("Pipeline Manager", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('admin', 'superadmin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 4,
                                clickable: "",
                                onClick: _ctx.onPigRunManagerWizard
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                      _createTextVNode("Pig Run Manager", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('admin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 5,
                                clickable: "",
                                onClick: _ctx.onDownloadManagerClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                      _createTextVNode("Download Manager", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('admin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 6,
                                clickable: "",
                                onClick: _ctx.onReportManagerClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                      _createTextVNode("Report Manager", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.userHasAnyRole('admin'))
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 7,
                                clickable: "",
                                onClick: _ctx.onBroadcastCommandsClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                      _createTextVNode("Broadcast Commands", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            : _createCommentVNode("", true),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _ctx.onNotificationSettings
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode("Notifications / SMS Opt-in", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_close_popup]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _ctx.onServiceStatus
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                  _createTextVNode("Service Status", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_close_popup]
                          ]),
                          _createVNode(_component_q_item, { clickable: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { onClick: _ctx.onTechSupportClick }, {
                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                  _createTextVNode("Technical Support", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_separator),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _ctx.onChangePassword
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                  _createTextVNode("Change Password", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_close_popup]
                          ]),
                          _createVNode(_component_q_separator),
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _ctx.onLogout
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                  _createTextVNode("Logout", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_close_popup]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_drawer, {
        modelValue: _ctx.leftDrawerOpen,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.leftDrawerOpen) = $event)),
        "show-if-above": "",
        bordered: "",
        width: _ctx.drawerMini ? 40 : 350,
        "content-class": "bg-grey-2",
        onHide: _ctx.drawerToggle,
        onShow: _ctx.drawerToggle
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["row q-pa-xs", _ctx.drawerMini ? 'justify-center' : 'justify-end'])
          }, [
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              round: "",
              icon: _ctx.drawerMini ? 'chevron_right' : 'chevron_left',
              "aria-label": _ctx.drawerMini ? 'Expand drawer' : 'Collapse drawer',
              onClick: _ctx.toggleDrawer
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.drawerMini ? 'Expand menu' : 'Collapse menu'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["icon", "aria-label", "onClick"])
          ], 2),
          (!_ctx.drawerMini)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_DeviceInfo),
                _createVNode(_component_DeviceTable),
                _createVNode(_component_PigRunManager),
                _createVNode(_component_ReportManager),
                _createVNode(_component_DownloadManager),
                _createVNode(_component_BroadcastCommands)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "width", "onHide", "onShow"]),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_Map)
        ]),
        _: 1
      }),
      (_ctx.devicesReady && _ctx.selectedPigRun)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(), _createBlock(_component_PigProgressCard, {
              key: _ctx.selectedPigRun.pigRunId,
              "pig-run": _ctx.selectedPigRun,
              position: 0
            }, null, 8, ["pig-run"]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}